import Users from "./modules/users";
import Resources from "./modules/resources";
import Product from "./modules/product";
import Project from "./modules/project";
import Promo from "./modules/promo";
import Pleated from "./modules/pleated";

export default {
    Users,
    Resources,
    Product,
    Project,
    Promo,
    Pleated
};
